import { render, staticRenderFns } from "./YearsSelector.vue?vue&type=template&id=1ae1982c&scoped=true&"
import script from "./YearsSelector.vue?vue&type=script&lang=ts&"
export * from "./YearsSelector.vue?vue&type=script&lang=ts&"
import style0 from "./YearsSelector.vue?vue&type=style&index=0&id=1ae1982c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ae1982c",
  null
  
)

export default component.exports